import { ApiHelper } from 'utils/apiHelper';

const apiVersioning = false;

export const AuthorisationApi = {
    async authTfa(code: string) {
        await ApiHelper.rpcCall<void>({
            apiVersioning, // TODO: make backend add version
            url: '/auth/tfa/enter',
            method: 'POST',
            data: {
                tfa_code: code,
            },
        });
    },
};
